import { atom } from 'recoil';

export const FocusInputState = atom({
    key: 'FocusInputState', 
    default: false, 
});